// modules
import { handleActions } from 'redux-actions'

// actions
import { setAlertNotes } from 'src/store/modules/reports/alertNotesReport'

const initialState = {
  alertNotesList: []
}

export default handleActions(
  {
    [setAlertNotes](state, { payload: alertNotesList }) {
      return {
        ...state,
        alertNotesList
      }
    }
  },
  initialState
)
